import type { ReactNode } from 'react'
import React, { createContext, useContext } from 'react'
import type { PersonId } from '@fs/zion-tree-types'
import { usePersonPageParams } from '../person-page/personPageRouteUtil'

const FocusPIDContext = createContext<PersonId | null>(null)

export const useFocusPID = (): PersonId | null => useContext(FocusPIDContext)

export default function FocusPIDProvider({ children }: { children: ReactNode }): JSX.Element {
  const { pid } = usePersonPageParams('full')
  return <FocusPIDContext.Provider value={pid}>{children}</FocusPIDContext.Provider>
}
